// TOP LEVEL IMPORTS
import React from 'react';
// COMPONENTS
import PageContainer from 'components/common/PageContainer';
import Button from 'components/common/Button';
import CustomDashboardForm from 'components/forms/CustomDashboardForm';
import AdminHeader from 'components/common/AdminHeader';
import CustomDashboardsTable from './CustomDashboardsTable';
// APOLLO
import allCustomDashboardsQuery from 'ApolloClient/Queries/allCustomDashboards';
import createCustomDashboard from 'ApolloClient/Mutations/createCustomDashboard';
import { graphql, compose } from 'react-apollo';
// LIB
import RecomposeHelpers from 'lib/helpers/RecomposeHelpers';
import ErrorHelpers from 'lib/helpers/ErrorHelpers';

class AdminDashboards extends React.PureComponent {
  state = {
    showAddDashboardForm: false,
  };

  toggleForm = () => {
    this.setState({ showAddDashboardForm: !this.state.showAddDashboardForm });
  };

  onCreateCustomDashboard = async (newDashboard) => {
    let variables = {
      params: {
        ...newDashboard,
      }
    }

    try {
      await this.props.createCustomDashboard({ variables });
    }
    catch(err){
      return ErrorHelpers.handleError(err)
    }
    this.toggleForm();
    window.location.reload();

  }
  render() {
    return (
      <PageContainer flex="center">
        {!this.state.showAddDashboardForm ? (
          <React.Fragment>
            <AdminHeader
              header="Dashboards "
              action={(
                <Button style={{ marginBottom: 20 }} onClick={this.toggleForm}>
                  + New Dashboard
                </Button>
              )}
            />
            <CustomDashboardsTable customDashboards={this.props.allCustomDashboardsQuery.allCustomDashboards} />
          </React.Fragment>
        ) : (
          <React.Fragment>
            <AdminHeader
              header="Add New Dashboard"
              action={(
                <a href="#" style={{ marginBottom: 20 }} onClick={this.toggleForm}>
                  Cancel
                </a>
              )}
            />
            <div>
            <CustomDashboardForm handleSubmit={this.onCreateCustomDashboard} /> 
            </div>
          </React.Fragment>
        )}
      </PageContainer>
    );
  }
}

export default compose(
  graphql(allCustomDashboardsQuery, { name: 'allCustomDashboardsQuery' }),
  graphql(createCustomDashboard, { name: 'createCustomDashboard' }),
)(AdminDashboards);



// WEBPACK FOOTER //
// ./src/routes/admin-dashboards/index.js